const formatters = new Map<string, Intl.DateTimeFormat>();

/** Reuse the fixed timing formats for each active application locale. */
export function runTimeFormatter(
  locale: string,
  format: 'time' | 'dateTime' | 'seconds',
) {
  const key = `${locale}:${format}`;
  let formatter = formatters.get(key);
  if (formatter) return formatter;
  const options: Intl.DateTimeFormatOptions = {
    hour: 'numeric',
    minute: '2-digit',
    ...(format === 'dateTime'
      ? { year: 'numeric', month: 'short', day: 'numeric' }
      : {}),
    ...(format === 'seconds' ? { second: '2-digit' } : {}),
  };
  formatter = new Intl.DateTimeFormat(locale, options);
  formatters.set(key, formatter);
  return formatter;
}

/** Use local calendar dates so crossing midnight never looks like a same-day run. */
export function compactRunTimeRange(
  start: Date,
  end: Date,
  { locale }: { locale: string },
): string {
  const sameDay = start.toDateString() === end.toDateString();
  const formatter = runTimeFormatter(locale, sameDay ? 'time' : 'dateTime');
  if (end.getTime() < start.getTime())
    return `${formatter.format(start)} – ${formatter.format(end)}`;
  return formatter.formatRange(start, end);
}

/** Never invent a positive duration for inverted recorded timestamps. */
export function runDurationParts(start: Date, end: Date) {
  const elapsed = end.getTime() - start.getTime();
  if (elapsed < 0) return null;
  const seconds = Math.round(elapsed / 1000);
  return {
    hours: String(Math.floor(seconds / 3600)),
    minutes: String(Math.floor(seconds / 60) % 60),
    seconds: String(seconds % 60),
  };
}
